import styled from 'styled-components';
import FilledTick from '../../../assets/svg/FilledTick';
import HeadingOutline2 from '../assets/svg/HeadingOutline2';
import { PUBLIC_IMAGES_REPO } from '../../../../../utils/Constants';

const Image1 = `${PUBLIC_IMAGES_REPO}/seo-section-Image-1.webp`;
const Image2 = `${PUBLIC_IMAGES_REPO}/seo-section-Image-2.webp`;
const Image3 = `${PUBLIC_IMAGES_REPO}/seo-section-Image-3.webp`;

const Wrapper = styled.section`
  background: var(--BG-Color, #f2f2f2);

  .container {
    max-width: 1440px;
    position: relative;
    display: flex;
    gap: 2.5rem;
    padding: 9.375rem 3.75rem 9.375rem 6.25rem;
    overflow: hidden;
  }

  .image-container {
    display: flex;
    gap: 1.5rem;
    width: 53%;

    .left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      img {
        min-height: 240px;
      }
    }
  }

  .outline-container {
    position: relative;
    padding: 0 10px;

    .outline {
      position: absolute;
      top: -10px;
      left: -5px;

      svg {
        width: 100%;
      }
    }
  }

  .content {
    width: 47%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 2rem;

    .mobile-image-container {
      display: none;
    }

    h2 {
      color: var(--font-color-font-1, #1b131f);

      font-family: Instrument Sans;
      font-size: 64px;
      font-style: normal;
      font-weight: 700;
      line-height: 88px;
    }

    p {
      color: var(--font-color-font-1, #1b131f);
      font-family: Instrument Sans;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px;
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        color: var(--font-color-font-1, #1b131f);
        font-family: Instrument Sans;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 32px;
        display: flex;
        gap: 0.5rem;
        padding: 8px;

        .icon {
          width: 10%;
        }

        p {
          margin: 0;
          width: 90%;
        }

        :not(:last-child) {
          margin-bottom: 1.5rem;
        }
      }
    }
  }

  .optimize-site {
    display: flex;
    transform: rotate(4.936deg);
    padding: 6px 12px;
    border-radius: 3px;
    border: none;
    background: var(--secoundary-secoundary-500-f, #cb1d8d);
    position: absolute;
    left: 24%;
    top: 22.5%;
    color: var(--white-shades-white-100, #fff);
    font-family: Instrument Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }

  @media screen and (max-width: 1024px) {
    .container {
      gap: 1.5rem;
      padding: 6.375rem 2.5rem 6.375rem 2.5rem;
    }

    .image-container {
      display: flex;
      gap: 0.5rem;
      width: 65%;

      img {
        width: 50%;
      }

      .left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        img {
          width: 100%;
        }
      }
    }

    .outline-container {
      position: relative;
      padding: 0 10px;

      .outline {
        position: absolute;
        top: -10px;
        left: -5px;

        svg {
          width: 100%;
        }
      }
    }

    .content {
      width: 35%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 0.5rem;

      .mobile-image-container {
        display: none;
      }

      h2 {
        font-size: 45px;
        line-height: 58px;
      }

      p {
        font-size: 18px;
        line-height: 28px;
      }

      ul {
        list-style: none;
        padding: 0;

        li {
          font-size: 18px;
          line-height: 328px;
          padding: 4px;

          .icon {
            width: 10%;
          }

          p {
            margin: 0;
            width: 90%;
          }

          :not(:last-child) {
            margin-bottom: 0.75rem;
          }
        }
      }
    }

    .optimize-site {
      display: flex;
      transform: rotate(4.936deg);
      padding: 6px 12px;
      border-radius: 3px;
      border: none;
      background: var(--secoundary-secoundary-500-f, #cb1d8d);
      position: absolute;
      left: 24%;
      top: 22.5%;
      color: var(--white-shades-white-100, #fff);
      font-family: Instrument Sans;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
  }

  @media screen and (max-width: 768px) {
    .container {
      gap: 2.5rem;
      padding: 2rem 1.25rem;
      flex-direction: column-reverse;
    }

    .image-container {
      display: none;
    }

    .outline-container {
      position: relative;
      padding: 0 10px;

      .outline {
        position: absolute;
        top: -5px;
        left: 0px;

        svg {
          width: 95%;
        }
      }
    }

    .content {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 0.5rem;

      .mobile-image-container {
        display: flex;
        justify-content: center;
        gap: 0.75rem;
        width: 100%;

        img {
          width: 46%;
        }

        .left {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          gap: 0.5rem;

          img {
            width: 100%;

            img {
              min-height: 105px;
            }
          }
        }
      }

      h2 {
        font-size: 32px;
        line-height: 40px;
      }

      p {
        font-size: 16px;
        line-height: 24px;
      }

      ul {
        list-style: none;
        padding: 0;

        li {
          font-size: 18px;
          line-height: 26px;

          .icon {
            width: 10%;
          }

          p {
            margin: 0;
            width: 90%;
          }

          :not(:last-child) {
            margin-bottom: 1rem;
          }
        }
      }
    }

    .optimize-site {
      padding: 4px 8px;
      left: 35%;
      top: 30%;
      font-size: 10px;
      line-height: 14px;
    }
  }

  @media screen and (max-width: 425px) {
    .content {
      .mobile-image-container {
        img {
          width: 52%;
        }
      }
    }
  }
`;
const list = [
  'Easily manage your SEO configuration within the platform',
  'Monitor the success of your SEO configuration',
  'View recommendations for improving your search strategy',
];

const SeoSection = () => {
  return (
    <Wrapper>
      <div className="container">
        <div className="image-container">
          <div className="left">
            <img
              loading="lazy"
              src={Image1}
              alt="Availability of Florist website SEO for all Florist web templates"
            />
            <img
              loading="lazy"
              src={Image2}
              alt="Availability of Florist website SEO for all Florist web templates"
            />
          </div>
          <img
            loading="lazy"
            src={Image3}
            alt="Availability of Florist website SEO for all Florist web templates"
          />
        </div>
        <div className="content">
          <h2>
            Flower Shop{' '}
            <span className="outline-container">
              SEO
              <span className="outline">
                <HeadingOutline2 />
              </span>
            </span>{' '}
          </h2>
          <p>
            Our SEO Management helps you optimize your website's content,
            structure, and overall online presence to improve its visibility and
            ranking in search engine results
          </p>
          <div className="mobile-image-container">
            <div className="left">
              <img
                loading="lazy"
                src={Image1}
                alt="Availability of Florist website SEO for all Florist web templates"
              />
              <img
                loading="lazy"
                src={Image2}
                alt="Availability of Florist website SEO for all Florist web templates"
              />
            </div>
            <img
              loading="lazy"
              src={Image3}
              alt="Availability of Florist website SEO for all Florist web templates"
            />
          </div>
          <ul>
            {list.map((item, index) => (
              <li key={index}>
                <FilledTick className="icon" />
                <p>{item}</p>
              </li>
            ))}
          </ul>
        </div>
        <button className="optimize-site">Optimize site</button>
      </div>
    </Wrapper>
  );
};

export default SeoSection;
